module.exports = __webpack_public_path__ + "img/yellow-circle-table-8.0e70a581.png";